/* szronwear landing: wybor zestawu, kolorow, dodanie do koszyka, sticky bar, upsell w koszyku */
(function () {
  if (window.szwReady) return;
  window.szwReady = true;

  var states = {};

  function rootOf(el) { return el.closest('[data-szw-section]'); }

  function dataOf(root) {
    var id = root.getAttribute('data-szw-section');
    if (states[id]) return states[id];
    var tag = root.querySelector('script[data-szw-data]');
    var data = tag ? JSON.parse(tag.textContent) : { variants: [] };
    var start = data.selected || (data.variants[0] && data.variants[0].id);
    states[id] = { data: data, qty: data.qty || 2, colors: [start, start, start] };
    return states[id];
  }

  function variant(state, id) {
    for (var i = 0; i < state.data.variants.length; i++) {
      if (String(state.data.variants[i].id) === String(id)) return state.data.variants[i];
    }
    return null;
  }

  function render(root) {
    var st = dataOf(root);
    root.querySelectorAll('[data-szw-tile]').forEach(function (t) {
      var on = Number(t.getAttribute('data-szw-tile')) === st.qty;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-szw-row]').forEach(function (row) {
      var r = Number(row.getAttribute('data-szw-row'));
      row.hidden = r >= st.qty;
      row.querySelectorAll('[data-szw-color]').forEach(function (b) {
        var on = String(b.getAttribute('data-szw-color')) === String(st.colors[r]);
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var name = row.querySelector('[data-szw-row-name]');
      var v = variant(st, st.colors[r]);
      if (name && v) name.textContent = v.title;
    });
    root.querySelectorAll('[data-szw-label-qty]').forEach(function (l) {
      l.hidden = st.qty === 1;
    });
    var price = st.data.prices[String(st.qty)];
    root.querySelectorAll('[data-szw-total]').forEach(function (el) { el.textContent = price; });
    root.querySelectorAll('[data-szw-sticky-qty]').forEach(function (el) {
      el.textContent = st.qty === 1 ? '1 czapka' : st.qty + ' czapki';
    });
    root.querySelectorAll('[data-szw-ship]').forEach(function (el) {
      el.textContent = st.qty === 1 ? '+ dostawa ' + st.data.shipFee : 'darmowa dostawa';
    });
    var first = variant(st, st.colors[0]);
    root.querySelectorAll('[data-szw-color-name]').forEach(function (el) {
      if (first) el.textContent = first.title;
    });
    var cmp = st.data.compare ? st.data.compare[String(st.qty)] : '';
    root.querySelectorAll('[data-szw-compare]').forEach(function (el) {
      el.textContent = cmp || '';
      el.hidden = !cmp;
    });
    root.querySelectorAll('[data-szw-promo]').forEach(function (el) {
      var t = el.getAttribute('data-t' + st.qty);
      var span = el.querySelector('[data-szw-promo-text]');
      if (t && span) span.textContent = t;
    });
  }

  function markThumb(root, mediaId) {
    root.querySelectorAll('[data-szw-thumb]').forEach(function (b) {
      b.classList.toggle('is-on', String(b.getAttribute('data-szw-thumb')) === String(mediaId));
    });
  }

  function showMedia(root, mediaId, instant) {
    if (!mediaId) return;
    var track = root.querySelector('[data-szw-track]');
    var item = track && track.querySelector('[data-media-id="' + mediaId + '"]');
    if (!item) return;
    track.scrollTo({ left: item.offsetLeft - track.offsetLeft - (track.clientWidth - item.clientWidth) / 2, behavior: instant ? 'auto' : 'smooth' });
    markThumb(root, mediaId);
  }

  function addToCart(root, btn) {
    var st = dataOf(root);
    var counts = {};
    for (var i = 0; i < st.qty; i++) counts[st.colors[i]] = (counts[st.colors[i]] || 0) + 1;
    var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
    var err = root.querySelector('[data-szw-error]');
    if (err) err.classList.remove('is-on');
    root.querySelectorAll('[data-szw-add]').forEach(function (b) { b.disabled = true; });
    fetch(st.data.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      window.location.href = st.data.cartUrl;
    }).catch(function () {
      root.querySelectorAll('[data-szw-add]').forEach(function (b) { b.disabled = false; });
      if (err) err.classList.add('is-on');
    });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-szw-thumb]');
    if (thumb && rootOf(thumb)) {
      showMedia(rootOf(thumb), thumb.getAttribute('data-szw-thumb'));
      return;
    }
    var tile = e.target.closest('[data-szw-tile]');
    if (tile) {
      var r1 = rootOf(tile);
      dataOf(r1).qty = Number(tile.getAttribute('data-szw-tile'));
      render(r1);
      return;
    }
    var sw = e.target.closest('[data-szw-color]');
    if (sw && sw.closest('[data-szw-row]')) {
      var r2 = rootOf(sw);
      var st = dataOf(r2);
      var row = Number(sw.closest('[data-szw-row]').getAttribute('data-szw-row'));
      st.colors[row] = sw.getAttribute('data-szw-color');
      render(r2);
      var v = variant(st, st.colors[row]);
      if (v) showMedia(r2, v.media);
      return;
    }
    var add = e.target.closest('[data-szw-add]');
    if (add && rootOf(add)) {
      e.preventDefault();
      addToCart(rootOf(add), add);
      return;
    }
    var up = e.target.closest('[data-szw-up-color]');
    if (up) {
      var box = up.closest('[data-szw-up]');
      box.setAttribute('data-szw-up-selected', up.getAttribute('data-szw-up-color'));
      box.querySelectorAll('[data-szw-up-color]').forEach(function (b) { b.classList.toggle('is-on', b === up); });
      return;
    }
    var quick = e.target.closest('[data-szw-quick]');
    if (quick) {
      quick.disabled = true;
      fetch(quick.getAttribute('data-szw-add-url'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(quick.getAttribute('data-szw-quick')), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        window.location.href = quick.getAttribute('data-szw-cart-url');
      }).catch(function () { quick.disabled = false; });
      return;
    }
    var upAdd = e.target.closest('[data-szw-up-add]');
    if (upAdd) {
      var box2 = upAdd.closest('[data-szw-up]');
      upAdd.disabled = true;
      fetch(box2.getAttribute('data-szw-add-url'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(box2.getAttribute('data-szw-up-selected')), quantity: 1 }] })
      }).then(function () { window.location.reload(); })
        .catch(function () { upAdd.disabled = false; });
    }
  });

  function init() {
    document.querySelectorAll('[data-szw-section]').forEach(function (root) {
      if (!root.querySelector('script[data-szw-data]')) return;
      render(root);

      // Wejscie z kafelka koloru (?variant=): galeria startuje od zdjecia tego koloru
      if (/[?&]variant=/.test(window.location.search)) {
        var st0 = dataOf(root);
        var v0 = variant(st0, st0.colors[0]);
        if (v0) showMedia(root, v0.media, true);
      }

      var track = root.querySelector('[data-szw-track]');
      var dots = root.querySelectorAll('[data-szw-dots] span');
      if (track && dots.length) {
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / (track.scrollWidth / dots.length));
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        }, { passive: true });
      }
      var thumbsBox = root.querySelector('[data-szw-thumbs]');
      if (track && thumbsBox) {
        var tm;
        track.addEventListener('scroll', function () {
          clearTimeout(tm);
          tm = setTimeout(function () {
            var items = track.children;
            var i = Math.round(track.scrollLeft / track.clientWidth);
            var it = items[Math.max(0, Math.min(items.length - 1, i))];
            if (!it) return;
            var id = it.getAttribute('data-media-id');
            markThumb(root, id);
            var tb = thumbsBox.querySelector('[data-szw-thumb="' + id + '"]');
            if (tb) thumbsBox.scrollTo({ left: tb.offsetLeft - thumbsBox.offsetLeft - 40, behavior: 'smooth' });
          }, 80);
        }, { passive: true });
      }

      var cta = root.querySelector('[data-szw-main-cta]');
      var sticky = root.querySelector('[data-szw-sticky]');
      if (cta && sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var en = entries[0];
          sticky.classList.toggle('is-on', !en.isIntersecting);
        }).observe(cta);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
